import React from "react";
import { formatDecimal } from "../utils/formatNumber";
import { buildResourceSummaryRows } from "../utils/resources";

export const ResourceSummaryTable = ({
  assignedResources,
  remainingResources,
  usageResources,
  className = "",
  isLoading = false,
  includeUsageOnly = true,
  additionalRows = [],
  unavailable = false,
  onRetry,
  notices = [],
}) => {
  const rows = [...buildResourceSummaryRows({
    assignedResources,
    remainingResources,
    usageResources,
    includeUsageOnly,
  }), ...additionalRows];
  const formatValue = value => (
    value === null || value === undefined ? "—" : formatDecimal(value)
  );

  return (
    <div className={`admin-resource-summary ${className}`}>
      <div className="table-responsive admin-resource-summary__scroll">
        <table className="table admin-resource-summary-table mb-0">
          <thead>
            <tr>
              <th>Recurso</th>
              <th className="admin-resource-summary-table__number">Asignadas</th>
              <th className="admin-resource-summary-table__number">Usadas</th>
              <th className="admin-resource-summary-table__number">Restantes</th>
            </tr>
          </thead>
          <tbody>
            {isLoading ? (
              <tr>
                <td colSpan="4" className="text-center py-6">
                  <span className="spinner-border spinner-border-sm text-primary mr-3" role="status">
                    <span className="sr-only">Cargando...</span>
                  </span>
                  Cargando datos...
                </td>
              </tr>
            ) : unavailable ? (
              <tr>
                <td colSpan="4" className="text-center py-6">
                  <span>No se pudieron cargar estos recursos.</span>
                  {onRetry && (
                    <button type="button" className="btn btn-link p-0 ml-2" onClick={onRetry}>
                      Reintentar
                    </button>
                  )}
                </td>
              </tr>
            ) : rows.map((row) => (
              <tr key={row.resourceId}>
                <td>{row.label}</td>
                <td className="admin-resource-summary-table__number">
                  {formatValue(row.assigned)}
                </td>
                <td className="admin-resource-summary-table__number">
                  {formatValue(row.used)}
                </td>
                <td className="admin-resource-summary-table__number">
                  {formatValue(row.remaining)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {notices.map(notice => (
        <div key={notice.key} className="admin-resource-summary__notice" role="status">
          <span>{notice.message}</span>
          {notice.onRetry && (
            <button type="button" className="btn btn-link p-0" onClick={notice.onRetry}>
              Reintentar
            </button>
          )}
        </div>
      ))}
    </div>
  );
};
